import { call, put, takeLatest } from 'redux-saga/effects'
import { handleApiErrors } from '../../lib/api-errors'
import axiosApi from '../../views/client/axiosClient'

import {
  HEADER_REQUESTING,
  HEADER_SET_ACTIVE_BRANCH_REQUESTING,
  HEADER_SET_ACTIVE_BRANCH_API,
  HEADER_REQUEST_API
} from './constants'

import {
  headerRequestSuccess,
  headerRequestError,
  headerSetActiveBranchSuccess,
  headerSetActiveBranchError,
} from './actions'

let _history = {};

function handleRequest (request) {
  return request
    .then( function(response){
      return handleApiErrors(response, _history);
    })
    .then( function(response){
      return response.data;
    })
    .then(json => json)
    .catch((error) => { 
      throw error;
    })
}

function headersRequestApi () {
  const request = axiosApi().get(HEADER_REQUEST_API)
  return handleRequest(request);
}

function headerSetActiveBranchApi (formData) {
  const request = axiosApi().post(
    HEADER_SET_ACTIVE_BRANCH_API, 
    formData
  )

  return handleRequest(request);
}

function* headersRequestFlow ({client}) {
  try {
    _history = client.history;

    // call to our headersRequestApi function with the client
    const results = yield call(headersRequestApi)
    // dispatch the action with our widgets!
    yield put(headerRequestSuccess(results))
  } catch (error) {
    yield put(headerRequestError(error))
  }
}

function* headerSetActiveBranchFlow ({client, formData}) {
  try {
    _history = client.history;
    // call to our headersRequestApi function with the client
    const results = yield call(headerSetActiveBranchApi, formData)
    // dispatch the action with our widgets!
    yield put(headerSetActiveBranchSuccess(results))
  } catch (error) {
    yield put(headerSetActiveBranchError(error))
  }
}

function* headersWatcher () {
  // each of the below RECEIVES the action from the .. action
  //const { client: { history } } = yield take(HEADER_REQUESTING)
  yield takeLatest(HEADER_REQUESTING, headersRequestFlow)
  yield takeLatest(HEADER_SET_ACTIVE_BRANCH_REQUESTING, headerSetActiveBranchFlow)
}

export default headersWatcher



// WEBPACK FOOTER //
// ./src/components/Header/sagas.js